import {Component} from "react";
import {Modal, ModalBody, ModalHeader} from "reactstrap";
import appLib from "../../libs/appLib.mjs";
import AppMainIcon from "../../media/app-images/AppMainIcon.mjs";
import "./AboutModal.css";

const prefix="AboutModal";

const AboutModal = class extends Component {
	render() {
		return (
			<Modal
				className={prefix}
				isOpen={true}
				toggle={this.props.close}
				backdrop={"static"}
				fade={false}
				onOpened={appLib.modalAutoFocus}
			>
				<ModalHeader toggle={this.props.close}>
					<AppMainIcon />
					Horus
				</ModalHeader>
				<ModalBody>
					<div className={"header"}>
						<AppMainIcon />
						<div>
							<h2>{ process.env.REACT_APP_DESCRIPTION } <small>v. { process.env.REACT_APP_VERSION }</small></h2>
							<p>Based on Domino, <span className={"copyright"}>2020-2026 Tesseract</span></p>
							<p>Custom version developed for ACN</p>
						</div>
					</div>
					<div className={"credits"}>
						<ul>
							<li>
								Project management:
								<ul>
									<li>Supervisor: <em>Luisa Franchina</em></li>
									<li>Project management: <em>M. Pedrazzi</em>, <em>C. Proietti</em></li>
								</ul>
							</li>
							<li>
								Development:
								<ul>
									<li>Supervisor: <em>Marco Balestra</em></li>
									<li>Senior developers: <em>M. Balestra</em>, <em>G. Chimisso</em></li>
									<li>Developers: <em>M. Di Tullo</em>, <em>T. Diddi</em>, <em>A. Longo</em></li>
									<li>Cloud specialists: <em>D. Lamanna</em>, <em>I. Pedone</em></li>
								</ul>
							</li>
							<li>
								<strong>PNSCgen</strong> by <em>Università La Sapienza, Roma</em>:
								<ul>
									<li>Supervisor: <em>Giuseppe Santucci</em></li>
									<li>Developers: <em>G. Blasilli</em>, <em>S. Lenti</em></li>
								</ul>
							</li>
							<li>
								<strong>Data RESTorage</strong> by M. Balestra &amp; Hermes Bay srl:
								<ul>
									<li>Supervisor: <em>Marco Balestra</em></li>
									<li>Developers: <em>M. Balestra</em>, <em>M. Di Tullo</em></li>
								</ul>
							</li>
							<li>Glyphicons <em><span className={"copyright"}>GLYPHICONS.com</span></em>, licensed to M. Balestra</li>
						</ul>
					</div>
				</ModalBody>
			</Modal>
		)
	}
}

export default AboutModal;